import { NotificationForm } from './NotificationForm';
import { NotificationsList } from './NotificationsList';
import { useNotifications } from './useNotifications';
import { useAuth } from '@/contexts/AuthContext';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export const AdminNotificationList = () => {
  const { notifications, isLoading, refetchNotifications } = useNotifications();
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          You do not have permission to view this page.
        </AlertDescription>
      </Alert>
    );
  }

  console.log('Current notifications:', notifications);

  return (
    <div className="space-y-6">
      <NotificationForm onNotificationSent={refetchNotifications} />
      
      <div className="max-w-2xl">
        {isLoading ? (
          <div className="text-gray-400">Loading notifications...</div>
        ) : notifications.length === 0 ? (
          <div className="text-gray-400">No notifications found</div>
        ) : (
          <NotificationsList notifications={notifications} />
        )}
      </div>
    </div>
  );
};